const selectState = state => state.signUp

export const selectSigningUp = state => selectState(state).signingUp
export const selectIsSubmitting = state => selectState(state).isSubmitting
export const selectErrors = state => selectState(state).errors
